import React from 'react';
import { Card, Table, Tag, Space, Typography } from 'antd';
import { 
    QuestionCircleOutlined,
    EnvironmentOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;

/**
 * 未匹配航班展示组件
 * 展示所有未能匹配到航线的航班
 */
const UnmatchedFlightsCard = ({ batchId, routeInstances }) => {
    // 从 route_instances 中筛选出未匹配的航班
    // 未匹配航班的特征是：没有 route_code 或 route_id 为 null
    const unmatchedFlights = routeInstances
        .filter(instance => !instance.route_code || instance.route_id === null)
        .flatMap(instance => instance.flights || []);

    if (unmatchedFlights.length === 0) {
        return null;
    }

    // 表格列定义
    const columns = [
        {
            title: '航班号',
            dataIndex: 'flight_number',
            key: 'flight_number',
            width: 120,
        },
        {
            title: '航段',
            key: 'route_segment',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Text strong>{record.departure_airport}</Text>
                    <EnvironmentOutlined style={{ color: '#ff4d4f' }} />
                    <Text strong>{record.arrival_airport}</Text>
                </Space>
            )
        },
        {
            title: '起飞时间 (ATD)',
            dataIndex: 'atd',
            key: 'atd',
            width: 180,
            render: (time) => {
                if (!time) return '-';
                const date = new Date(time);
                return (
                    <Space>
                        <ClockCircleOutlined />
                        <span>{date.toLocaleString('zh-CN', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</span>
                    </Space>
                );
            }
        },
        {
            title: '到达时间 (ATA)',
            dataIndex: 'ata',
            key: 'ata',
            width: 180,
            render: (time) => {
                if (!time) return '-';
                const date = new Date(time);
                return (
                    <Space>
                        <ClockCircleOutlined />
                        <span>{date.toLocaleString('zh-CN', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</span>
                    </Space>
                );
            }
        },
        {
            title: '成本 (USD)',
            dataIndex: 'total_cost',
            key: 'total_cost',
            width: 130,
            align: 'right',
            render: (cost) => (
                <Text strong>
                    ${Number(cost).toLocaleString('en-US', { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2 
                    })}
                </Text>
            )
        }
    ];

    return (
        <Card 
            style={{ marginTop: 16, borderColor: '#ff4d4f' }}
            title={
                <Space>
                    <QuestionCircleOutlined style={{ color: '#ff4d4f' }} />
                    <Title level={5} style={{ margin: 0 }}>
                        未匹配航班 ({unmatchedFlights.length} 个)
                    </Title>
                </Space>
            }
        >
            <Table
                columns={columns}
                dataSource={unmatchedFlights}
                rowKey="flight_id"
                pagination={false}
                size="small"
                bordered
            />
        </Card>
    );
};

export default UnmatchedFlightsCard;

